import type { ReactNode } from "react";

export function PageSection({ title, description, actions, children, className = "" }: { title?: string; description?: string; actions?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <section className={`page-section ${className}`.trim()}>
      {title || actions ? <header className="page-section__header"><div>{title ? <h2>{title}</h2> : null}{description ? <p>{description}</p> : null}</div>{actions ? <div className="page-section__actions">{actions}</div> : null}</header> : null}
      {children}
    </section>
  );
}
